import { RpcShellNavigate, RpcShellNavigateResult } from './rpc-shell-navigate-model';

/**
 * Rpc shell navigate sever side handler interface.
 */
export interface RpcShellNavigateHandler {
    handler(data: RpcShellNavigate): Promise<RpcShellNavigateResult>;
}
